import React, { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux';
import AgGridTable from 'src/components/AgGridTable'

const columnDefPortafolio = [
  {headerName: 'ID Recurso', field: "ID_RECURSO", resizable: true, sortable: true, filter: false, width: 50},
  {headerName: 'Recurso', field: "RECURSO", resizable: true, sortable: true, filter: true, width: 80},
  {headerName: 'Fecha Ingreso', field: "FECHA_INGRESO", resizable: true, sortable: true, filter: true, width: 80},
  {headerName: 'Fecha Salida', field: "FECHA_SALIDA", resizable: true, sortable: true, filter: true, width: 80},
  {headerName: 'ID Segmento', field: "SEGMENTO", resizable: true, sortable: true, filter: true, width: 80},
  {headerName: 'ID Modelo atención', field: "MODELO_ATENCION", resizable: true, sortable: true, filter: true, width: 80},
  {headerName: 'ID Ciudad', field: "CIUDAD", resizable: true, sortable: true, filter: true, width: 80},
  {headerName: 'Estado', field: "ESTADO", resizable: true, sortable: true, filter: true, width: 80},
  {headerName: 'Acción', field: "TIPO_REGISTRO", resizable: true, sortable: true, filter: true, width: 80},
  {headerName: 'Error', field: "error", resizable: true, sortable: true, filter: true, width: 80, hide: true},
  {headerName: 'Fila', field: "fila", resizable: true, sortable: true, filter: true, width: 80, hide: false},
]

const columnDefSubportafolio = [
  {headerName: 'ID Recurso', field: "ID_RECURSO", resizable: true, sortable: true, filter: false, width: 50},
  {headerName: 'Recurso', field: "RECURSO", resizable: true, sortable: true, filter: true, width: 80},
  {headerName: 'Fecha Ingreso', field: "FECHA_INGRESO", resizable: true, sortable: true, filter: true, width: 80},
  {headerName: 'Fecha Salida', field: "FECHA_SALIDA", resizable: true, sortable: true, filter: true, width: 80},
  {headerName: 'Estado', field: "ESTADO", resizable: true, sortable: true, filter: true, width: 80},
  {headerName: 'Acción', field: "TIPO_REGISTRO", resizable: true, sortable: true, filter: true, width: 80},
  {headerName: 'Error', field: "error", resizable: true, sortable: true, filter: true, width: 80, hide: true},
  {headerName: 'Fila', field: "fila", resizable: true, sortable: true, filter: true, width: 80, hide: false},
]

const TableExcel = ({properties}) => {

  const { procesados, noprocesados, isPortafolio } = properties 
  const tableRef = useRef(null);
  const validoRef = useRef(null);
  const errorRef = useRef(null);
  const [dataRow, setDataRow] = useState([])

  //useEFFECT
  useEffect(() => {
    validoRef.current.innerText = procesados.length 
    errorRef.current.innerText = noprocesados.length

    setDataRow(procesados.concat(noprocesados));    
  }, [])

const getRowStyle = (params) => {
  if(params.node.data.error){
    return { 'background-color': '#FAEDE6'}
  }else{
    return { 'background-color': '#D8F5E2'}
  }
}

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center">
        <div className='d-flex align-items-center justify-content-sm-around w-25'>
          <div>
            <strong style={{fontSize: 20}}>Validos: </strong>
            <span ref={validoRef} style={{fontSize: 20, color: '#64DF38', fontWeight: 'bold'}}> 0</span>
          </div>
          <div>
            <strong style={{fontSize: 20}}>Errores: </strong>
            <span ref={errorRef} style={{fontSize: 20, color: 'red', fontWeight: 'bold'}}> 0</span>
          </div>
        </div>
      </div>
      <div >
        <AgGridTable
          referencia={tableRef}
          columnDef={isPortafolio ? columnDefPortafolio : columnDefSubportafolio}
          dataList={dataRow || []}
          rowSelection={'single'}
          getRowStyle={getRowStyle}
        /> 
      </div>
    </div>
  )
}

export default TableExcel